// src/components/ui/EmailStatusBadge.jsx

import React from 'react';
import { motion } from 'framer-motion';

export const EmailStatusBadge = ({
  emailVerified,
  email,
  size = 'md',
  showLabel = true,
  className = '',
}) => {
  // Determine size classes
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  const isVerified = emailVerified === true;
  const baseClasses = 'inline-flex items-center gap-2 rounded-full font-medium';

  // Color scheme based on verification status
  const colorClasses = isVerified
    ? 'bg-green-100 text-green-700 border border-green-300'
    : 'bg-yellow-100 text-yellow-700 border border-yellow-300';

  const tooltip = isVerified
    ? 'Email verified ✓'
    : `Verify email: ${email || 'email not found'}`;

  return (
    <motion.div
      className={`${baseClasses} ${sizeClasses[size]} ${colorClasses} ${className}`}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
      title={tooltip}
    >
      {/* Icon */}
      {isVerified ? (
        <motion.svg
          className={`${iconSizes[size]} flex-shrink-0`}
          fill="currentColor"
          viewBox="0 0 20 20"
          initial={{ rotate: -180 }}
          animate={{ rotate: 0 }}
          transition={{ duration: 0.4, type: 'spring' }}
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </motion.svg>
      ) : (
        <motion.svg
          className={`${iconSizes[size]} flex-shrink-0`}
          fill="currentColor"
          viewBox="0 0 20 20"
          initial={{ rotate: 180 }}
          animate={{ rotate: 0 }}
          transition={{ duration: 0.4, type: 'spring' }}
        >
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </motion.svg>
      )}

      {/* Label */}
      {showLabel && (
        <span className="font-medium">
          {isVerified ? 'Verified' : 'Unverified'}
        </span>
      )}
    </motion.div>
  );
};

export default EmailStatusBadge;